import Styles from './UserMetrics.module.scss';
import { useState, useContext, useEffect, Fragment } from 'react';

import { useNavigate, ViewContext, AuthContext, useAPI, Message, useTranslation, useCan } from 'components/lib';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

import FeatherIcon from 'feather-icons-react';
import * as FeatherIconsList from 'feather-icons-react';
import {
    Tooltip, Pagination,
    // TextField, InputAdornment
} from '@mui/material';
import axios from 'axios';

export const MetricsCard = ({ metricsData, showReport, configURL, cardOnClick }) => {

    const { t } = useTranslation();
    const IconComponent = FeatherIconsList[metricsData.icon]
    const permission = useCan('user.metrics.assessments.view')
    const permissionAdmin = useCan('user.admin.metrics.assessments.view')
    const authContext = useContext(AuthContext)

    const navigate = useNavigate()

    return (
        <>
            <div
                id='metricsCard'
                className={Styles.metricsCard}
                onClick={cardOnClick}
            >
                <IconComponent size="1em" />
                <span className={Styles.metricDetails}>
                    <span className={Styles.metricName}>
                        {metricsData.name}
                    </span>
                    <span id='metricsDetails' className={Styles.metricsNumbers}>
                        {metricsData.metricStatus === "closed" &&
                            <span className={Styles.metricStatus}>
                                {metricsData.metricStatus.toUpperCase()}
                                <FeatherIcon
                                    color='black'
                                    icon='circle'
                                    size="0.6em"
                                />
                            </span>
                        }

                        <span className={Styles.metricsNumDetails}>
                            {Object.keys(metricsData).includes("assessments") &&
                                <>
                                    {t('QualityQuotient.UserMetrics.metricCard.assessments')}{metricsData.assessments}
                                </>
                            }
                            {Object.keys(metricsData).includes("attempts") &&
                                <>
                                    {t('QualityQuotient.UserMetrics.metricCard.attempts')}{metricsData.attempts}
                                </>
                            }
                        </span>
                        <FeatherIcon
                            color='black'
                            icon='circle'
                            size="0.5em"
                        />
                        <span style={{ width: "9ch" }}>
                            Score: {metricsData.score || "N/A"}
                        </span>
                        <FeatherIcon
                            color='black'
                            icon='circle'
                            size="0.5em"
                        />
                        <span style={{ width: "5ch" }}>
                            {metricsData.percentage || 0}%
                        </span>
                    </span>
                </span>
                <span id='metricActions' className={Styles.metricActions}>
                    {showReport &&
                        <Tooltip
                            title={
                                metricsData.status !== "Completed" ?
                                    t('QualityQuotient.UserMetrics.tooltip.finish')
                                    : t('QualityQuotient.UserMetrics.tooltip.report')
                            }
                        >
                            <span>
                                <button
                                    className={Styles.iconButton}
                                    disabled={metricsData.status !== "Completed"}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate(`/user/metrics/${metricsData.id}/report`)
                                    }}
                                >
                                    <FeatherIcon
                                        color='black'
                                        icon='file-text'
                                        size="1em"
                                    />
                                </button>
                            </span>
                        </Tooltip>
                    }
                    {permission && permissionAdmin && 
                        <Tooltip arrow placement="right" title={t('QualityQuotient.UserMetrics.tooltip.edit')}>
                            <button
                                className={Styles.iconButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(configURL)
                                }}
                            >
                                <FeatherIcon
                                    color='black'
                                    icon='settings'
                                    size="1em"
                                />
                            </button>
                        </Tooltip>
                    }
                </span>
            </div>
        </>
    )
}

export function UserMetrics(props) {

    const { data, loading } = useAPI('/api/user/metrics')

    const authContext = useContext(AuthContext)
    const viewContext = useContext(ViewContext)
    const permission = useCan('user.metrics.view')
    const permissionAdmin = useCan('user.admin.metrics.view')
    const navigate = useNavigate()

    const [userMetrics, setUserMetrics] = useState([])

    useEffect(() => {
        if (data?.metrics?.length) {
            setUserMetrics(data.metrics)
        }
    }, [data])

    // const [searchString, setSearchString] = useState(-1)

    // const onSearchInput = () => {
    //     viewContext.notification.show("Searching searching searching", "success")
    //     return;
    //     // const options = {
    //     //     method: "",
    //     //     url: ``,
    //     //     headers: {
    //     //         "accept": "application/json",
    //     //     },
    //     //     data: {},
    //     // };
    //     // axios
    //     //     .request(options)
    //     //     .then(function (response) {

    //     //         viewContext.notification.show(response.data.message, "success")
    //     //     })
    //     //     .catch((err) => {
    //     //         viewContext.handleError(err);
    //     //     });
    // }

    const handlePageChange = (event, pageNumber) => {
        const options = {
            method: "GET",
            url: `/api/user/metrics?limit=10&pageNumber=${pageNumber}`,
            headers: {
                "accept": "application/json",
            },
        };
        axios
            .request(options)
            .then(function (response) {
                setUserMetrics(response?.data?.data?.metrics)
            })
            .catch((err) => {
                viewContext.handleError(err);
            });
    };

    return (
        <>
            {loading && <LoadingBackdrop isOpen={loading} />}
            <Message
                closable
                title={props.t('QualityQuotient.UserMetrics.message.title')}
                text={props.t('QualityQuotient.UserMetrics.message.text')}
                type="info"
            />
            <div id='ancestorContainer' className={Styles.ancestorContainer}>
                <div id='headerContainer' className={Styles.headerContainer}>
                    <BreadCrumbs
                        onClickPaths={[
                            ''
                        ]}
                        crumbs={[
                            props.t('QualityQuotient.UserMetrics.breadcrumb')
                        ]}
                    />
                    <span>
                        <AivagamButton
                            type="back"
                            id="saveForm"
                            buttonText={
                                <>
                                    {props.t('QualityQuotient.UserMetrics.button.enroll')}
                                </>
                            }
                            onClick={() => navigate('/user/metrics/enroll')}
                        />
                        {permission && permissionAdmin && 
                            <AivagamButton
                                id="saveForm"
                                buttonText={
                                    <>
                                        <FeatherIcon
                                            color='white'
                                            icon='plus'
                                        />
                                        {props.t('QualityQuotient.UserMetrics.button.add')}
                                    </>
                                }
                                icon
                                onClick={() => {
                                    // console.log("clicked")
                                    navigate('/metrics/create')
                                }}
                            />
                        }
                    </span>
                </div>
                {userMetrics?.length !== 0 &&
                    <div id='searchContainer' className={Styles.searchContainer}>
                        {/* <Tooltip
                        // title={searchString !== -1 && props.t('Labs.LabsPurchase.search.tooltip')}
                        title={searchString !== -1 && "Click the search icon to search!"}
                        arrow
                        placement='right'
                    >
                        <TextField
                            onChange={(e) => setSearchString(e.target.value)}
                            onFocus={() => { }}
                            id='searchBox'
                            // placeholder={props.t('Labs.LabsPurchase.search.placeholder')}
                            placeholder={"Search"}
                            size='small'
                            value={searchString === -1 ? "" : searchString}
                            // defaultValue='Search'
                            sx={{ m: 1, width: "20vw", borderRadius: '10px', marginTop: "10px" }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    onSearchInput()
                                } else if (e.key === 'Escape') {
                                    console.log("Clear Search")
                                }
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {
                                            <>
                                                <button
                                                    onClick={() => { setSearchString(-1) }}
                                                    className={Styles.iconButton}
                                                    disabled={searchString === -1}
                                                >
                                                    <FeatherIcon
                                                        color='black'
                                                        icon='x'
                                                    />
                                                </button>
                                                <button
                                                    onClick={onSearchInput}
                                                    className={Styles.iconButton}
                                                    disabled={searchString === -1 || searchString === ""}
                                                >
                                                    <FeatherIcon
                                                        color='black'
                                                        icon='search'
                                                    />
                                                </button>
                                            </>
                                        }
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Tooltip> */}
                        <span>
                            {props.t('QualityQuotient.UserMetrics.total',
                                { current: userMetrics?.length, total: data?.total }
                            )}
                        </span>
                        <Pagination
                            count={data?.pages}
                            color="primary"
                            onChange={handlePageChange}
                            size="small"
                            sx={{
                                maxWidth: "50%",
                                marginLeft: "auto"
                            }}
                        />
                    </div>
                }
                <div id='metricsContainer' className={Styles.metricsContainer}>
                    {userMetrics?.map((metric, index) => {
                        if (metric.assessments !== 0) {
                            return (
                                <Fragment key={metric.id}>
                                    <MetricsCard
                                        metricsData={metric}
                                        showReport={true}
                                        configURL={`/metrics/${metric.id}/edit`}
                                        cardOnClick={() => navigate(`/user/metrics/${metric.id}/assessments`)}
                                    />
                                </Fragment>
                            )
                        } else {
                            return null;
                        }
                    })}
                    {
                        userMetrics?.length === 0 &&
                        <>
                            <p style={{ marginBottom: "auto", marginTop: "10vh" }}>
                                {props.t('QualityQuotient.UserMetrics.info.two')}
                            </p>
                            <p>
                                {props.t('QualityQuotient.UserMetrics.info.one')}
                            </p>
                            <AivagamButton
                                type="back"
                                id="saveForm"
                                classStyles={{
                                    textDecoration: "underline"
                                }}
                                buttonText={
                                    <>
                                        {props.t('QualityQuotient.UserMetrics.button.enroll')}
                                    </>
                                }
                                onClick={() => navigate('/user/metrics/enroll')}
                            />
                        </>
                    }
                </div>
                <div
                    id='paginationContainer'
                    className={Styles.searchContainer}
                    style={{ justifyContent: "center", marginTop: "auto" }}
                >
                    <Pagination
                        count={data?.pages}
                        color="primary"
                        onChange={handlePageChange}
                        size="small"
                        sx={{
                            marginTop: "2em"
                        }}
                    />
                </div>
            </div>
        </>
    );
}